/**
 * Canonical SDK field projections for the `/settings` surface (FQ-097).
 *
 * Plain (non-`'use client'`) module so the SSR `settings/page.tsx` prefetch
 * can import without pulling a client component into the server bundle. Args
 * + `fields` MUST byte-match the client hook callsites or the dehydrated
 * cache key misses and the panel renders `isPending`.
 *
 * Direct on-mount query callsites on this surface:
 *   - `ProfilePanel` + `ConnectionsPanel` → `useGetAuthProviders({ fields: SETTINGS_AUTH_PROVIDERS_FIELDS })`
 *   - `SessionsList` (mounted by `SecurityPanel`) → `useGetSessions({ kind: 'sessions', fields: SETTINGS_SESSIONS_FIELDS })`
 *
 * The Wallets panel reads from the SDK-owned wallets context (`useWallets()`),
 * not a v2 query hook, so no projection is needed for it. `useUpdateProfile`
 * optimistically targets `useGetMe`, but no component on this surface mounts
 * `useGetMe` directly — the optimistic engine creates the cache entry lazily
 * if it doesn't exist, so we deliberately do NOT prefetch `useGetMe`.
 */

/** Element type — every field the settings auth-providers callsites read. */
export type SettingsAuthProvidersField = 'providers';

/** Scoped field set for `useGetAuthProviders` on the settings surface. */
export const SETTINGS_AUTH_PROVIDERS_FIELDS: readonly SettingsAuthProvidersField[] = ['providers'];

/** Element type — every field the settings sessions callsite reads. */
export type SettingsSessionsField = 'sessions';

/** Scoped field set for `useGetSessions` on the settings surface. */
export const SETTINGS_SESSIONS_FIELDS: readonly SettingsSessionsField[] = ['sessions'];
